

































import { Component } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import WindowVue from "@/app/core/window/WindowVue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import { CutInDeclareInfo } from "@/@types/room";
import NekostoreCollectionController from "@/app/core/api/app-server/NekostoreCollectionController";
import VueEvent from "@/app/core/decorator/VueEvent";
import BgmManager from "@/app/basic/cut-in/bgm/BgmManager";
import BgmInfoForm from "@/app/basic/cut-in/bgm/BgmInfoForm.vue";

@Component({
  components: {
    BgmInfoForm,
    CtrlButton
  }
})
export default class BgmAddWindow extends Mixins<WindowVue<void, never>>(
  WindowVue
) {
  private cc: NekostoreCollectionController<
    CutInDeclareInfo
  > = SocketFacade.instance.cutInDataCC();

  private url: string = "";
  private title: string = "";
  private tag: string = "";
  private isRepeat: boolean = false;
  private fadeIn: number = 0;
  private fadeOut: number = 0;
  private start: number = 0;
  private end: number = 0;
  private volume: number = 80;
  private chatLinkageType: "none" | "last" | "regexp" = "none";
  private chatLinkageTarget: string = "";
  private isStandBy: boolean = false;
  private isForceContinue: boolean = false;
  private isForceNew: boolean = false;

  @LifeCycle
  public async mounted() {
    await this.init();
  }

  @VueEvent
  private async preview() {
    await BgmManager.instance.callBgm({
      targetId: null,
      data: this.cutInData
    });
  }

  @VueEvent
  private async commit() {
    await this.cc!.addDirect([this.cutInData]);
    await this.close();
  }

  private get cutInData(): CutInDeclareInfo {
    return {
      url: this.url,
      title: this.title,
      tag: this.tag,
      isRepeat: this.isRepeat,
      fadeIn: this.fadeIn,
      fadeOut: this.fadeOut,
      start: this.start,
      end: this.end,
      volume: this.volume,
      chatLinkageType: this.chatLinkageType,
      chatLinkageTarget: this.chatLinkageTarget,
      isStandBy: this.isStandBy,
      isForceContinue: this.isForceContinue,
      isForceNew: this.isForceNew
    };
  }

  @VueEvent
  private async rollback() {
    await this.close();
  }
}
